import './icon-button.scss'
import { Icon as IconOCC } from '@vista-digital/occ-ui'
import type { FC, MouseEventHandler } from 'react'
import { cx } from '@/common/utils/className'

export interface IconButtonProps {
    iconName: string
    label?: string
    iconSize?: number | string
    href?: string
    className?: string
    onClick?: MouseEventHandler<HTMLButtonElement>
    mode?: 'icon-first' | 'text-first'
}

/**
 * Component to render anchor or button with an icon.
 * @param {string} href will make automatically make it return a tag if not null
 */

export const IconButton: FC<IconButtonProps> = props => {
    const { iconName, label, onClick, href, className, iconSize = '100%', mode = 'text-first' } = props
    // @ts-expect-error -- size accepts both number and string, this type is incorrect
    const Icon = () => <IconOCC name={iconName} size={iconSize} />
    const cls = cx('icon-button', className, mode, { iconOnly: !label })

    if (href) {
        return (
            <a href={href} className={cls}>
                {label && <span className="icon-button__label">{label}</span>}
                <Icon />
            </a>
        )
    }

    return (
        <button className={cls} onClick={onClick}>
            {label && <span className="icon-button__label">{label}</span>}
            <Icon />
        </button>
    )
}
